import React from 'react';
import { CLOSE_ICON, SEARCH_ICON } from './constants';
const SearchContentToggleIcon = ({
  onClick,
  useCloseIcon
}) => /*#__PURE__*/React.createElement("svg", {
  className: "search-content--expanded__icon",
  viewBox: "0 0 20 20",
  onClick: onClick,
  "data-testid": useCloseIcon ? 'search-content-icon-close' : 'search-content-icon'
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: useCloseIcon ? CLOSE_ICON : SEARCH_ICON
}));
export default SearchContentToggleIcon;
//# sourceMappingURL=SearchContentToggleIcon.js.map